import { useQuery } from "@tanstack/react-query";
import { API_URL } from "@/constants/envVariables";
import { fetchApi } from "@/helpers/fetchApi";
import { ApiUser, AppError } from "@/types";

export const USERS_QUERY_KEY = ["users"] as const;

export const useUsers = (options?: { enabled?: boolean }) => {
  const query = useQuery<ApiUser[], AppError>({
    queryKey: USERS_QUERY_KEY,
    queryFn: async () => {
      return await fetchApi(`${API_URL}/users`);
    },
    enabled: options?.enabled ?? true,
  });

  return query;
};
